// Generouted, changes to this file will be overriden
/* eslint-disable */

import { components, hooks, utils } from '@generouted/react-router/client'

export type Path =
  | `/`
  | `/activities`
  | `/activities/activity-types`
  | `/activities/activity-types/:activityTypeId`
  | `/activities/activity-types/:activityTypeId/MobileActivityTypeLandingPage`
  | `/activities/activity-types/:activityTypeId/TableColumns`
  | `/activities/activity-types/:activityTypeId/activities`
  | `/activities/activity-types/:activityTypeId/activity/:activityId`
  | `/activities/activity-types/:activityTypeId/activity/:activityId/add-participants`
  | `/activities/activity-types/:activityTypeId/activity/:activityId/edit`
  | `/activities/activity-types/:activityTypeId/activity/:activityId/participants`
  | `/activities/activity-types/:activityTypeId/create`
  | `/activities/activity-types/:activityTypeId/participants`
  | `/activities/activity-types/:activityTypeId/participants/:participantId`
  | `/activities/activity-types/TableColumns`
  | `/activities/events`
  | `/activities/events/:eventSlug`
  | `/activities/events/:eventSlug/attendance`
  | `/activities/events/:eventSlug/attendance/finalize`
  | `/activities/events/:eventSlug/cancellations`
  | `/activities/events/:eventSlug/edit`
  | `/activities/events/:eventSlug/leads`
  | `/activities/events/:eventSlug/manual-registrations`
  | `/activities/events/:eventSlug/notes`
  | `/activities/events/:eventSlug/overview`
  | `/activities/events/:eventSlug/payouts`
  | `/activities/events/:eventSlug/recap`
  | `/activities/events/:eventSlug/registrations`
  | `/activities/events/:eventSlug/registrations/:registrationId`
  | `/activities/events/:eventSlug/results`
  | `/activities/events/:eventSlug/waitlist`
  | `/activities/events/new`
  | `/assume-user`
  | `/billing`
  | `/billing/dues-management`
  | `/billing/dues-management/manage-products`
  | `/billing/dues-management/manage-products/annual-national-rates`
  | `/billing/dues-management/manage-products/annual-section-rates`
  | `/billing/dues-management/reporting`
  | `/billing/dues-management/reporting/suspensions`
  | `/billing/dues-management/reporting/terminations`
  | `/billing/dues-management/reporting/unpaid-dues`
  | `/billing/dues-management/suspensions-and-terminations`
  | `/billing/dues-management/suspensions-and-terminations/suspensions`
  | `/billing/dues-management/suspensions-and-terminations/terminations`
  | `/billing/finance`
  | `/billing/finance/grp`
  | `/billing/finance/grp/enrollments`
  | `/billing/finance/grp/member-contributions`
  | `/billing/finance/grp/sponsor-contributions`
  | `/billing/finance/grp/sponsor-contributions/upload`
  | `/billing/orders`
  | `/billing/orders/:orderId`
  | `/billing/orders/:orderId/payment/:paymentId`
  | `/billing/orders/apply-payment`
  | `/billing/orders/edit-order/:orderId`
  | `/billing/orders/payment/:paymentId`
  | `/billing/payments`
  | `/billing/payout-profiles`
  | `/configuration`
  | `/configuration/career-consultants`
  | `/configuration/player-engagement`
  | `/configuration/recruiters`
  | `/dev/chat`
  | `/dev/chat-logs`
  | `/dev/mcp-playground`
  | `/education`
  | `/education/universities`
  | `/education/universities/:universityId`
  | `/education/universities/:universityId/MobileUniversityLandingPage`
  | `/education/universities/:universityId/details`
  | `/education/universities/:universityId/events`
  | `/education/universities/:universityId/events/:eventSlug`
  | `/education/universities/:universityId/events/:eventSlug/attendance`
  | `/education/universities/:universityId/events/:eventSlug/attendance/finalize`
  | `/education/universities/:universityId/events/:eventSlug/cancellations`
  | `/education/universities/:universityId/events/:eventSlug/edit`
  | `/education/universities/:universityId/events/:eventSlug/leads`
  | `/education/universities/:universityId/events/:eventSlug/manual-registrations`
  | `/education/universities/:universityId/events/:eventSlug/notes`
  | `/education/universities/:universityId/events/:eventSlug/overview`
  | `/education/universities/:universityId/events/:eventSlug/payouts`
  | `/education/universities/:universityId/events/:eventSlug/recap`
  | `/education/universities/:universityId/events/:eventSlug/registrations`
  | `/education/universities/:universityId/events/:eventSlug/registrations/:registrationId`
  | `/education/universities/:universityId/events/:eventSlug/results`
  | `/education/universities/:universityId/events/:eventSlug/waitlist`
  | `/education/universities/:universityId/events/new`
  | `/education/universities/:universityId/internships`
  | `/education/universities/:universityId/internships/alumni`
  | `/education/universities/:universityId/internships/current`
  | `/education/universities/:universityId/reports`
  | `/education/universities/:universityId/reports/internship-reporting`
  | `/education/universities/:universityId/reports/past-roster-uploads`
  | `/education/universities/:universityId/reports/semester`
  | `/education/universities/:universityId/staff`
  | `/education/universities/:universityId/students`
  | `/education/universities/:universityId/students/:studentId`
  | `/education/universities/:universityId/students/:studentId/contact`
  | `/education/universities/:universityId/students/:studentId/internships`
  | `/education/universities/:universityId/students/:studentId/notes`
  | `/education/universities/:universityId/students/:studentId/pat-results`
  | `/education/universities/:universityId/students/:studentId/test-results`
  | `/education/universities/:universityId/students/EditCohortDialog`
  | `/education/universities/:universityId/students/alumni`
  | `/education/universities/:universityId/students/current`
  | `/education/universities/:universityId/students/eligible-for-enrollment`
  | `/education/universities/:universityId/students/graduation-eligible`
  | `/education/universities/:universityId/students/probations`
  | `/education/universities/:universityId/students/probations/ProbationModal`
  | `/education/universities/:universityId/students/report`
  | `/education/universities/:universityId/students/upload-roster`
  | `/education/universities/:universityId/test-results`
  | `/education/universities/:universityId/test-results/alumni`
  | `/education/universities/:universityId/test-results/current`
  | `/education/universities/:universityId/test-results/pat-statuses`
  | `/education/videos`
  | `/education/videos/:videoSlug`
  | `/education/videos/:videoSlug/queries`
  | `/education/videos/:videoSlug/show`
  | `/education/videos/assessmentDetails`
  | `/education/videos/publish-video`
  | `/education/videos/videoDetails`
  | `/errors`
  | `/events`
  | `/events/:eventSlug`
  | `/events/:eventSlug/attendance`
  | `/events/:eventSlug/attendance/finalize`
  | `/events/:eventSlug/attendance/queries`
  | `/events/:eventSlug/cancellations`
  | `/events/:eventSlug/edit`
  | `/events/:eventSlug/leads`
  | `/events/:eventSlug/notes`
  | `/events/:eventSlug/overview`
  | `/events/:eventSlug/payouts`
  | `/events/:eventSlug/recap`
  | `/events/:eventSlug/registrations`
  | `/events/:eventSlug/registrations/:registrationId`
  | `/events/:eventSlug/results`
  | `/events/:eventSlug/waitlist`
  | `/events/new`
  | `/events/pat-results`
  | `/facilities`
  | `/facilities/:facilityId`
  | `/facilities/:facilityId/MobileFacilityLandingPage`
  | `/facilities/:facilityId/admin-tools`
  | `/facilities/:facilityId/details`
  | `/facilities/:facilityId/details/contact`
  | `/facilities/:facilityId/details/notes`
  | `/facilities/:facilityId/jobs`
  | `/facilities/:facilityId/jobs/all-jobs`
  | `/facilities/:facilityId/jobs/job-post/:jobPostId`
  | `/facilities/:facilityId/jobs/job-post/:jobPostId/applicants`
  | `/facilities/:facilityId/jobs/job-post/:jobPostId/details`
  | `/facilities/:facilityId/jobs/job-post/:jobPostId/interactions`
  | `/facilities/:facilityId/jobs/job-post/:jobPostId/interactions/:interactionId`
  | `/facilities/:facilityId/jobs/job-post/:jobPostId/outcome`
  | `/facilities/:facilityId/jobs/job-post/:jobPostId/reviews`
  | `/facilities/:facilityId/jobs/job-post/close/:jobPostId`
  | `/facilities/:facilityId/jobs/job-post/create`
  | `/facilities/:facilityId/jobs/job-post/edit/:jobPostId`
  | `/facilities/:facilityId/jobs/permissions`
  | `/facilities/:facilityId/people`
  | `/facilities/:facilityId/people/employees`
  | `/facilities/:facilityId/people/former_employees`
  | `/facilities/:facilityId/people/governance`
  | `/facilities/new`
  | `/home`
  | `/home/roster`
  | `/jobs`
  | `/jobs/all-jobs`
  | `/jobs/execusearch`
  | `/jobs/job-post/:jobPostId`
  | `/jobs/job-post/:jobPostId/applicants`
  | `/jobs/job-post/:jobPostId/details`
  | `/jobs/job-post/:jobPostId/interactions`
  | `/jobs/job-post/:jobPostId/interactions/:interactionId`
  | `/jobs/job-post/:jobPostId/outcome`
  | `/jobs/job-post/:jobPostId/reviews`
  | `/jobs/job-post/close/:jobPostId`
  | `/jobs/job-post/create`
  | `/jobs/job-post/edit/:jobPostId`
  | `/jobs/my-jobs`
  | `/people`
  | `/people/:pgaId`
  | `/people/:pgaId/MobilePersonLandingPage`
  | `/people/:pgaId/admin-tools`
  | `/people/:pgaId/benefits`
  | `/people/:pgaId/benefits/beneficiaries`
  | `/people/:pgaId/benefits/beneficiaries/update/:applicationType`
  | `/people/:pgaId/billing`
  | `/people/:pgaId/billing/orders`
  | `/people/:pgaId/billing/payout-profiles`
  | `/people/:pgaId/billing/payout-profiles/:payoutProfileId/view`
  | `/people/:pgaId/career`
  | `/people/:pgaId/career/awards`
  | `/people/:pgaId/career/career-plan`
  | `/people/:pgaId/career/career-plan/:day`
  | `/people/:pgaId/career/career-plan/:day/assessment`
  | `/people/:pgaId/career/career-plan/new`
  | `/people/:pgaId/career/career-plan/onboarding`
  | `/people/:pgaId/career/career-plan/plans/:planId`
  | `/people/:pgaId/career/career-profile`
  | `/people/:pgaId/career/career-profile/:day`
  | `/people/:pgaId/career/career-profile/:day/assessment`
  | `/people/:pgaId/career/career-profile/experience-assessment`
  | `/people/:pgaId/career/career-profile/experience-assessment/assessment`
  | `/people/:pgaId/career/career-profile/goals`
  | `/people/:pgaId/career/career-profile/latest`
  | `/people/:pgaId/career/career-profile/new`
  | `/people/:pgaId/career/career-profile/onboarding`
  | `/people/:pgaId/career/career-profile/plans`
  | `/people/:pgaId/career/career-profile/plans/:planId`
  | `/people/:pgaId/career/compensation`
  | `/people/:pgaId/career/compensation-profiles`
  | `/people/:pgaId/career/compensation-profiles/:compProfileId/edit`
  | `/people/:pgaId/career/compensation-profiles/:compProfileId/view`
  | `/people/:pgaId/career/compensation-profiles/create`
  | `/people/:pgaId/career/compensation/:compProfileId/edit`
  | `/people/:pgaId/career/compensation/:compProfileId/view`
  | `/people/:pgaId/career/compensation/create`
  | `/people/:pgaId/career/employment`
  | `/people/:pgaId/career/governance-roles`
  | `/people/:pgaId/career/job-applications`
  | `/people/:pgaId/career/job-postings`
  | `/people/:pgaId/career/job-preferences`
  | `/people/:pgaId/career/overview`
  | `/people/:pgaId/education`
  | `/people/:pgaId/education/certifications`
  | `/people/:pgaId/education/credentials`
  | `/people/:pgaId/education/learning`
  | `/people/:pgaId/education/professional-development`
  | `/people/:pgaId/education/professional-development/:activityId`
  | `/people/:pgaId/education/program`
  | `/people/:pgaId/events`
  | `/people/:pgaId/events/cancellations`
  | `/people/:pgaId/events/participation-history`
  | `/people/:pgaId/events/registrations`
  | `/people/:pgaId/interactions`
  | `/people/:pgaId/interactions/interactions`
  | `/people/:pgaId/interactions/interactions/:interactionId`
  | `/people/:pgaId/interactions/person-history`
  | `/people/:pgaId/membership`
  | `/people/:pgaId/membership/applications`
  | `/people/:pgaId/membership/committees`
  | `/people/:pgaId/membership/overview`
  | `/people/:pgaId/membership/path-to-membership`
  | `/people/:pgaId/membership/path-to-membership/background-check`
  | `/people/:pgaId/membership/prospect-program`
  | `/people/:pgaId/membership/section`
  | `/people/:pgaId/person`
  | `/people/:pgaId/person/audit-log`
  | `/people/:pgaId/person/change-history`
  | `/people/:pgaId/person/change-requests`
  | `/people/:pgaId/person/committees`
  | `/people/:pgaId/person/contact`
  | `/people/:pgaId/person/details`
  | `/people/:pgaId/person/documents`
  | `/people/:pgaId/person/employment`
  | `/people/:pgaId/person/groups`
  | `/people/:pgaId/person/membership`
  | `/people/:pgaId/person/notes`
  | `/people/:pgaId/person/overview`
  | `/people/:pgaId/person/section`
  | `/people/:pgaId/person/timeline`
  | `/people/applications`
  | `/people/applications/:applicationId`
  | `/people/applications/:applicationId/details`
  | `/people/applications/:applicationId/notes`
  | `/people/applications/:applicationId/overview`
  | `/people/member-elections`
  | `/people/member-elections/upcoming-dates`
  | `/people/membership-services`
  | `/people/membership-services/achievements-report`
  | `/people/membership-services/applications`
  | `/people/membership-services/applications/:applicationId`
  | `/people/membership-services/applications/:applicationId/details`
  | `/people/membership-services/applications/:applicationId/notes`
  | `/people/membership-services/applications/:applicationId/overview`
  | `/people/membership-services/applications/affiliate`
  | `/people/membership-services/applications/all`
  | `/people/membership-services/applications/associate`
  | `/people/membership-services/applications/member`
  | `/people/membership-services/applications/reciprocity`
  | `/people/membership-services/committees`
  | `/people/membership-services/committees/:committeeId`
  | `/people/membership-services/committees/active`
  | `/people/membership-services/committees/all`
  | `/people/membership-services/committees/inactive`
  | `/people/membership-services/legacy-committees`
  | `/people/membership-services/legacy-committees/active`
  | `/people/membership-services/legacy-committees/all`
  | `/people/membership-services/legacy-committees/inactive`
  | `/people/membership-services/member-elections`
  | `/people/membership-services/member-elections/upcoming-dates`
  | `/people/person-merge-purge`
  | `/photobooth`
  | `/preferences`
  | `/search`
  | `/sections`
  | `/sections/:sectionId`
  | `/sections/:sectionId/MobileSectionLandingPage`
  | `/sections/:sectionId/audit-log`
  | `/sections/:sectionId/billing`
  | `/sections/:sectionId/billing/dues-rates`
  | `/sections/:sectionId/change-requests`
  | `/sections/:sectionId/change-requests/settings`
  | `/sections/:sectionId/jobs`
  | `/sections/:sectionId/jobs/job-post/:jobPostId`
  | `/sections/:sectionId/jobs/job-post/:jobPostId/applicants`
  | `/sections/:sectionId/jobs/job-post/:jobPostId/details`
  | `/sections/:sectionId/jobs/job-post/:jobPostId/interactions`
  | `/sections/:sectionId/jobs/job-post/:jobPostId/interactions/:interactionId`
  | `/sections/:sectionId/jobs/job-post/:jobPostId/outcome`
  | `/sections/:sectionId/jobs/job-post/:jobPostId/reviews`
  | `/sections/:sectionId/jobs/job-post/close/:jobPostId`
  | `/sections/:sectionId/jobs/job-post/create`
  | `/sections/:sectionId/jobs/job-post/edit/:jobPostId`
  | `/sections/:sectionId/jobs/list`
  | `/sections/:sectionId/operations`
  | `/sections/:sectionId/operations/committees`
  | `/sections/:sectionId/operations/committees/:committeeId`
  | `/sections/:sectionId/operations/contact`
  | `/sections/:sectionId/operations/employees`
  | `/sections/:sectionId/operations/governance`
  | `/sections/:sectionId/operations/notifications`
  | `/sections/:sectionId/people`
  | `/sections/:sectionId/people/change-requests`
  | `/sections/:sectionId/people/change-requests/settings`
  | `/sections/:sectionId/people/section-people`
  | `/sections/:sectionId/roster-activity`
  | `/storybook`
  | `/tasks`
  | `/tasks/:taskId`
  | `/tasks/all-tasks`
  | `/tasks/department-tasks`
  | `/tasks/my-tasks`

export type Params = {
  '/activities/activity-types/:activityTypeId': { activityTypeId: string }
  '/activities/activity-types/:activityTypeId/MobileActivityTypeLandingPage': { activityTypeId: string }
  '/activities/activity-types/:activityTypeId/TableColumns': { activityTypeId: string }
  '/activities/activity-types/:activityTypeId/activities': { activityTypeId: string }
  '/activities/activity-types/:activityTypeId/activity/:activityId': { activityTypeId: string; activityId: string }
  '/activities/activity-types/:activityTypeId/activity/:activityId/add-participants': { activityTypeId: string; activityId: string }
  '/activities/activity-types/:activityTypeId/activity/:activityId/edit': { activityTypeId: string; activityId: string }
  '/activities/activity-types/:activityTypeId/activity/:activityId/participants': { activityTypeId: string; activityId: string }
  '/activities/activity-types/:activityTypeId/create': { activityTypeId: string }
  '/activities/activity-types/:activityTypeId/participants': { activityTypeId: string }
  '/activities/activity-types/:activityTypeId/participants/:participantId': { activityTypeId: string; participantId: string }
  '/activities/events/:eventSlug': { eventSlug: string }
  '/activities/events/:eventSlug/attendance': { eventSlug: string }
  '/activities/events/:eventSlug/attendance/finalize': { eventSlug: string }
  '/activities/events/:eventSlug/cancellations': { eventSlug: string }
  '/activities/events/:eventSlug/edit': { eventSlug: string }
  '/activities/events/:eventSlug/leads': { eventSlug: string }
  '/activities/events/:eventSlug/manual-registrations': { eventSlug: string }
  '/activities/events/:eventSlug/notes': { eventSlug: string }
  '/activities/events/:eventSlug/overview': { eventSlug: string }
  '/activities/events/:eventSlug/payouts': { eventSlug: string }
  '/activities/events/:eventSlug/recap': { eventSlug: string }
  '/activities/events/:eventSlug/registrations': { eventSlug: string }
  '/activities/events/:eventSlug/registrations/:registrationId': { eventSlug: string; registrationId: string }
  '/activities/events/:eventSlug/results': { eventSlug: string }
  '/activities/events/:eventSlug/waitlist': { eventSlug: string }
  '/billing/orders/:orderId': { orderId: string }
  '/billing/orders/:orderId/payment/:paymentId': { orderId: string; paymentId: string }
  '/billing/orders/edit-order/:orderId': { orderId: string }
  '/billing/orders/payment/:paymentId': { paymentId: string }
  '/education/universities/:universityId': { universityId: string }
  '/education/universities/:universityId/MobileUniversityLandingPage': { universityId: string }
  '/education/universities/:universityId/details': { universityId: string }
  '/education/universities/:universityId/events': { universityId: string }
  '/education/universities/:universityId/events/:eventSlug': { universityId: string; eventSlug: string }
  '/education/universities/:universityId/events/:eventSlug/attendance': { universityId: string; eventSlug: string }
  '/education/universities/:universityId/events/:eventSlug/attendance/finalize': { universityId: string; eventSlug: string }
  '/education/universities/:universityId/events/:eventSlug/cancellations': { universityId: string; eventSlug: string }
  '/education/universities/:universityId/events/:eventSlug/edit': { universityId: string; eventSlug: string }
  '/education/universities/:universityId/events/:eventSlug/leads': { universityId: string; eventSlug: string }
  '/education/universities/:universityId/events/:eventSlug/manual-registrations': { universityId: string; eventSlug: string }
  '/education/universities/:universityId/events/:eventSlug/notes': { universityId: string; eventSlug: string }
  '/education/universities/:universityId/events/:eventSlug/overview': { universityId: string; eventSlug: string }
  '/education/universities/:universityId/events/:eventSlug/payouts': { universityId: string; eventSlug: string }
  '/education/universities/:universityId/events/:eventSlug/recap': { universityId: string; eventSlug: string }
  '/education/universities/:universityId/events/:eventSlug/registrations': { universityId: string; eventSlug: string }
  '/education/universities/:universityId/events/:eventSlug/registrations/:registrationId': { universityId: string; eventSlug: string; registrationId: string }
  '/education/universities/:universityId/events/:eventSlug/results': { universityId: string; eventSlug: string }
  '/education/universities/:universityId/events/:eventSlug/waitlist': { universityId: string; eventSlug: string }
  '/education/universities/:universityId/events/new': { universityId: string }
  '/education/universities/:universityId/internships': { universityId: string }
  '/education/universities/:universityId/internships/alumni': { universityId: string }
  '/education/universities/:universityId/internships/current': { universityId: string }
  '/education/universities/:universityId/reports': { universityId: string }
  '/education/universities/:universityId/reports/internship-reporting': { universityId: string }
  '/education/universities/:universityId/reports/past-roster-uploads': { universityId: string }
  '/education/universities/:universityId/reports/semester': { universityId: string }
  '/education/universities/:universityId/staff': { universityId: string }
  '/education/universities/:universityId/students': { universityId: string }
  '/education/universities/:universityId/students/:studentId': { universityId: string; studentId: string }
  '/education/universities/:universityId/students/:studentId/contact': { universityId: string; studentId: string }
  '/education/universities/:universityId/students/:studentId/internships': { universityId: string; studentId: string }
  '/education/universities/:universityId/students/:studentId/notes': { universityId: string; studentId: string }
  '/education/universities/:universityId/students/:studentId/pat-results': { universityId: string; studentId: string }
  '/education/universities/:universityId/students/:studentId/test-results': { universityId: string; studentId: string }
  '/education/universities/:universityId/students/EditCohortDialog': { universityId: string }
  '/education/universities/:universityId/students/alumni': { universityId: string }
  '/education/universities/:universityId/students/current': { universityId: string }
  '/education/universities/:universityId/students/eligible-for-enrollment': { universityId: string }
  '/education/universities/:universityId/students/graduation-eligible': { universityId: string }
  '/education/universities/:universityId/students/probations': { universityId: string }
  '/education/universities/:universityId/students/probations/ProbationModal': { universityId: string }
  '/education/universities/:universityId/students/report': { universityId: string }
  '/education/universities/:universityId/students/upload-roster': { universityId: string }
  '/education/universities/:universityId/test-results': { universityId: string }
  '/education/universities/:universityId/test-results/alumni': { universityId: string }
  '/education/universities/:universityId/test-results/current': { universityId: string }
  '/education/universities/:universityId/test-results/pat-statuses': { universityId: string }
  '/education/videos/:videoSlug': { videoSlug: string }
  '/education/videos/:videoSlug/queries': { videoSlug: string }
  '/education/videos/:videoSlug/show': { videoSlug: string }
  '/events/:eventSlug': { eventSlug: string }
  '/events/:eventSlug/attendance': { eventSlug: string }
  '/events/:eventSlug/attendance/finalize': { eventSlug: string }
  '/events/:eventSlug/attendance/queries': { eventSlug: string }
  '/events/:eventSlug/cancellations': { eventSlug: string }
  '/events/:eventSlug/edit': { eventSlug: string }
  '/events/:eventSlug/leads': { eventSlug: string }
  '/events/:eventSlug/notes': { eventSlug: string }
  '/events/:eventSlug/overview': { eventSlug: string }
  '/events/:eventSlug/payouts': { eventSlug: string }
  '/events/:eventSlug/recap': { eventSlug: string }
  '/events/:eventSlug/registrations': { eventSlug: string }
  '/events/:eventSlug/registrations/:registrationId': { eventSlug: string; registrationId: string }
  '/events/:eventSlug/results': { eventSlug: string }
  '/events/:eventSlug/waitlist': { eventSlug: string }
  '/facilities/:facilityId': { facilityId: string }
  '/facilities/:facilityId/MobileFacilityLandingPage': { facilityId: string }
  '/facilities/:facilityId/admin-tools': { facilityId: string }
  '/facilities/:facilityId/details': { facilityId: string }
  '/facilities/:facilityId/details/contact': { facilityId: string }
  '/facilities/:facilityId/details/notes': { facilityId: string }
  '/facilities/:facilityId/jobs': { facilityId: string }
  '/facilities/:facilityId/jobs/all-jobs': { facilityId: string }
  '/facilities/:facilityId/jobs/job-post/:jobPostId': { facilityId: string; jobPostId: string }
  '/facilities/:facilityId/jobs/job-post/:jobPostId/applicants': { facilityId: string; jobPostId: string }
  '/facilities/:facilityId/jobs/job-post/:jobPostId/details': { facilityId: string; jobPostId: string }
  '/facilities/:facilityId/jobs/job-post/:jobPostId/interactions': { facilityId: string; jobPostId: string }
  '/facilities/:facilityId/jobs/job-post/:jobPostId/interactions/:interactionId': { facilityId: string; jobPostId: string; interactionId: string }
  '/facilities/:facilityId/jobs/job-post/:jobPostId/outcome': { facilityId: string; jobPostId: string }
  '/facilities/:facilityId/jobs/job-post/:jobPostId/reviews': { facilityId: string; jobPostId: string }
  '/facilities/:facilityId/jobs/job-post/close/:jobPostId': { facilityId: string; jobPostId: string }
  '/facilities/:facilityId/jobs/job-post/create': { facilityId: string }
  '/facilities/:facilityId/jobs/job-post/edit/:jobPostId': { facilityId: string; jobPostId: string }
  '/facilities/:facilityId/jobs/permissions': { facilityId: string }
  '/facilities/:facilityId/people': { facilityId: string }
  '/facilities/:facilityId/people/employees': { facilityId: string }
  '/facilities/:facilityId/people/former_employees': { facilityId: string }
  '/facilities/:facilityId/people/governance': { facilityId: string }
  '/jobs/job-post/:jobPostId': { jobPostId: string }
  '/jobs/job-post/:jobPostId/applicants': { jobPostId: string }
  '/jobs/job-post/:jobPostId/details': { jobPostId: string }
  '/jobs/job-post/:jobPostId/interactions': { jobPostId: string }
  '/jobs/job-post/:jobPostId/interactions/:interactionId': { jobPostId: string; interactionId: string }
  '/jobs/job-post/:jobPostId/outcome': { jobPostId: string }
  '/jobs/job-post/:jobPostId/reviews': { jobPostId: string }
  '/jobs/job-post/close/:jobPostId': { jobPostId: string }
  '/jobs/job-post/edit/:jobPostId': { jobPostId: string }
  '/people/:pgaId': { pgaId: string }
  '/people/:pgaId/MobilePersonLandingPage': { pgaId: string }
  '/people/:pgaId/admin-tools': { pgaId: string }
  '/people/:pgaId/benefits': { pgaId: string }
  '/people/:pgaId/benefits/beneficiaries': { pgaId: string }
  '/people/:pgaId/benefits/beneficiaries/update/:applicationType': { pgaId: string; applicationType: string }
  '/people/:pgaId/billing': { pgaId: string }
  '/people/:pgaId/billing/orders': { pgaId: string }
  '/people/:pgaId/billing/payout-profiles': { pgaId: string }
  '/people/:pgaId/billing/payout-profiles/:payoutProfileId/view': { pgaId: string; payoutProfileId: string }
  '/people/:pgaId/career': { pgaId: string }
  '/people/:pgaId/career/awards': { pgaId: string }
  '/people/:pgaId/career/career-plan': { pgaId: string }
  '/people/:pgaId/career/career-plan/:day': { pgaId: string; day: string }
  '/people/:pgaId/career/career-plan/:day/assessment': { pgaId: string; day: string }
  '/people/:pgaId/career/career-plan/new': { pgaId: string }
  '/people/:pgaId/career/career-plan/onboarding': { pgaId: string }
  '/people/:pgaId/career/career-plan/plans/:planId': { pgaId: string; planId: string }
  '/people/:pgaId/career/career-profile': { pgaId: string }
  '/people/:pgaId/career/career-profile/:day': { pgaId: string; day: string }
  '/people/:pgaId/career/career-profile/:day/assessment': { pgaId: string; day: string }
  '/people/:pgaId/career/career-profile/experience-assessment': { pgaId: string }
  '/people/:pgaId/career/career-profile/experience-assessment/assessment': { pgaId: string }
  '/people/:pgaId/career/career-profile/goals': { pgaId: string }
  '/people/:pgaId/career/career-profile/latest': { pgaId: string }
  '/people/:pgaId/career/career-profile/new': { pgaId: string }
  '/people/:pgaId/career/career-profile/onboarding': { pgaId: string }
  '/people/:pgaId/career/career-profile/plans': { pgaId: string }
  '/people/:pgaId/career/career-profile/plans/:planId': { pgaId: string; planId: string }
  '/people/:pgaId/career/compensation': { pgaId: string }
  '/people/:pgaId/career/compensation-profiles': { pgaId: string }
  '/people/:pgaId/career/compensation-profiles/:compProfileId/edit': { pgaId: string; compProfileId: string }
  '/people/:pgaId/career/compensation-profiles/:compProfileId/view': { pgaId: string; compProfileId: string }
  '/people/:pgaId/career/compensation-profiles/create': { pgaId: string }
  '/people/:pgaId/career/compensation/:compProfileId/edit': { pgaId: string; compProfileId: string }
  '/people/:pgaId/career/compensation/:compProfileId/view': { pgaId: string; compProfileId: string }
  '/people/:pgaId/career/compensation/create': { pgaId: string }
  '/people/:pgaId/career/employment': { pgaId: string }
  '/people/:pgaId/career/governance-roles': { pgaId: string }
  '/people/:pgaId/career/job-applications': { pgaId: string }
  '/people/:pgaId/career/job-postings': { pgaId: string }
  '/people/:pgaId/career/job-preferences': { pgaId: string }
  '/people/:pgaId/career/overview': { pgaId: string }
  '/people/:pgaId/education': { pgaId: string }
  '/people/:pgaId/education/certifications': { pgaId: string }
  '/people/:pgaId/education/credentials': { pgaId: string }
  '/people/:pgaId/education/learning': { pgaId: string }
  '/people/:pgaId/education/professional-development': { pgaId: string }
  '/people/:pgaId/education/professional-development/:activityId': { pgaId: string; activityId: string }
  '/people/:pgaId/education/program': { pgaId: string }
  '/people/:pgaId/events': { pgaId: string }
  '/people/:pgaId/events/cancellations': { pgaId: string }
  '/people/:pgaId/events/participation-history': { pgaId: string }
  '/people/:pgaId/events/registrations': { pgaId: string }
  '/people/:pgaId/interactions': { pgaId: string }
  '/people/:pgaId/interactions/interactions': { pgaId: string }
  '/people/:pgaId/interactions/interactions/:interactionId': { pgaId: string; interactionId: string }
  '/people/:pgaId/interactions/person-history': { pgaId: string }
  '/people/:pgaId/membership': { pgaId: string }
  '/people/:pgaId/membership/applications': { pgaId: string }
  '/people/:pgaId/membership/committees': { pgaId: string }
  '/people/:pgaId/membership/overview': { pgaId: string }
  '/people/:pgaId/membership/path-to-membership': { pgaId: string }
  '/people/:pgaId/membership/path-to-membership/background-check': { pgaId: string }
  '/people/:pgaId/membership/prospect-program': { pgaId: string }
  '/people/:pgaId/membership/section': { pgaId: string }
  '/people/:pgaId/person': { pgaId: string }
  '/people/:pgaId/person/audit-log': { pgaId: string }
  '/people/:pgaId/person/change-history': { pgaId: string }
  '/people/:pgaId/person/change-requests': { pgaId: string }
  '/people/:pgaId/person/committees': { pgaId: string }
  '/people/:pgaId/person/contact': { pgaId: string }
  '/people/:pgaId/person/details': { pgaId: string }
  '/people/:pgaId/person/documents': { pgaId: string }
  '/people/:pgaId/person/employment': { pgaId: string }
  '/people/:pgaId/person/groups': { pgaId: string }
  '/people/:pgaId/person/membership': { pgaId: string }
  '/people/:pgaId/person/notes': { pgaId: string }
  '/people/:pgaId/person/overview': { pgaId: string }
  '/people/:pgaId/person/section': { pgaId: string }
  '/people/:pgaId/person/timeline': { pgaId: string }
  '/people/applications/:applicationId': { applicationId: string }
  '/people/applications/:applicationId/details': { applicationId: string }
  '/people/applications/:applicationId/notes': { applicationId: string }
  '/people/applications/:applicationId/overview': { applicationId: string }
  '/people/membership-services/applications/:applicationId': { applicationId: string }
  '/people/membership-services/applications/:applicationId/details': { applicationId: string }
  '/people/membership-services/applications/:applicationId/notes': { applicationId: string }
  '/people/membership-services/applications/:applicationId/overview': { applicationId: string }
  '/people/membership-services/committees/:committeeId': { committeeId: string }
  '/sections/:sectionId': { sectionId: string }
  '/sections/:sectionId/MobileSectionLandingPage': { sectionId: string }
  '/sections/:sectionId/audit-log': { sectionId: string }
  '/sections/:sectionId/billing': { sectionId: string }
  '/sections/:sectionId/billing/dues-rates': { sectionId: string }
  '/sections/:sectionId/change-requests': { sectionId: string }
  '/sections/:sectionId/change-requests/settings': { sectionId: string }
  '/sections/:sectionId/jobs': { sectionId: string }
  '/sections/:sectionId/jobs/job-post/:jobPostId': { sectionId: string; jobPostId: string }
  '/sections/:sectionId/jobs/job-post/:jobPostId/applicants': { sectionId: string; jobPostId: string }
  '/sections/:sectionId/jobs/job-post/:jobPostId/details': { sectionId: string; jobPostId: string }
  '/sections/:sectionId/jobs/job-post/:jobPostId/interactions': { sectionId: string; jobPostId: string }
  '/sections/:sectionId/jobs/job-post/:jobPostId/interactions/:interactionId': { sectionId: string; jobPostId: string; interactionId: string }
  '/sections/:sectionId/jobs/job-post/:jobPostId/outcome': { sectionId: string; jobPostId: string }
  '/sections/:sectionId/jobs/job-post/:jobPostId/reviews': { sectionId: string; jobPostId: string }
  '/sections/:sectionId/jobs/job-post/close/:jobPostId': { sectionId: string; jobPostId: string }
  '/sections/:sectionId/jobs/job-post/create': { sectionId: string }
  '/sections/:sectionId/jobs/job-post/edit/:jobPostId': { sectionId: string; jobPostId: string }
  '/sections/:sectionId/jobs/list': { sectionId: string }
  '/sections/:sectionId/operations': { sectionId: string }
  '/sections/:sectionId/operations/committees': { sectionId: string }
  '/sections/:sectionId/operations/committees/:committeeId': { sectionId: string; committeeId: string }
  '/sections/:sectionId/operations/contact': { sectionId: string }
  '/sections/:sectionId/operations/employees': { sectionId: string }
  '/sections/:sectionId/operations/governance': { sectionId: string }
  '/sections/:sectionId/operations/notifications': { sectionId: string }
  '/sections/:sectionId/people': { sectionId: string }
  '/sections/:sectionId/people/change-requests': { sectionId: string }
  '/sections/:sectionId/people/change-requests/settings': { sectionId: string }
  '/sections/:sectionId/people/section-people': { sectionId: string }
  '/sections/:sectionId/roster-activity': { sectionId: string }
  '/tasks/:taskId': { taskId: string }
}

export type ModalPath = never

export const { Link, Navigate } = components<Path, Params>()
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>()
export const { redirect } = utils<Path, Params>()
